import { memo } from 'react';
import { Col, Row } from 'antd';
import styled from 'styled-components';
import { LecturerBlocks, LocationBlocks, SubjectBlocks, TimetableBlocksProps } from '@modules/timetable';
import { HSMSContentCard, HSMSLoading } from '@components/shared';
import { themeConfig, colors } from '@theme/index';

const TimetableBlocksWrapper = styled(HSMSContentCard)`
  .divided-col {
    border-right: 1px solid ${colors.borderColor};
  }
`;

export const TimetableBlocks = memo(
  ({ subjectsLoading, batchSubjects, locationDataLoading, locationData }: TimetableBlocksProps) => {
    return (
      <TimetableBlocksWrapper>
        <Row gutter={themeConfig.grid.formInputRowGroupGutter}>
          <Col md={11} lg={9} className="divided-col" id="timetable-subject-blocks">
            {subjectsLoading ? <HSMSLoading height={134} /> : <SubjectBlocks batchSubjects={batchSubjects} />}
          </Col>

          <Col md={8} lg={7} className="divided-col" id="timetable-lecturer-blocks">
            {subjectsLoading ? <HSMSLoading height={134} /> : <LecturerBlocks batchSubjects={batchSubjects} />}
          </Col>

          <Col md={5} lg={7} id="timetable-location-blocks">
            {locationDataLoading ? <HSMSLoading height={134} /> : <LocationBlocks locationData={locationData} />}
          </Col>
        </Row>
      </TimetableBlocksWrapper>
    );
  },
);
